
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiNoInput as ObiNoInputElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-no-input.js';
 
 
 

 
 export const ObiNoInput = createComponent({
   react: React,
   tagName: 'obi-no-input',
   elementClass: ObiNoInputElement,
   events: {
     
   }
  });
 
 